// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const appletun: PokeData = {
  "id": 842,
  "name": "appletun",
  "height": 4,
  "weight": 130,
  "base_experience": 170,
  "types": [
    PokeType.GRASS,
    PokeType.DRAGON
  ],
  "api_moves": [
    "stomp",
    "headbutt",
    "body-slam",
    "leech-seed",
    "growth",
    "recover",
    "withdraw",
    "curse",
    "protect",
    "sweet-scent",
    "recycle",
    "astonish",
    "bullet-seed",
    "iron-defense",
    "dragon-pulse",
    "energy-ball",
    "apple-acid"
  ],
  "moves": [
    "headbutt",
    "body-slam",
    "curse",
    "protect",
    "bullet-seed",
    "dragon-pulse",
    "energy-ball",
    "flower-rush",
    "draco-meteor",
    "dragon-fang",
    "dragon-claw",
    "dragon-rush",
    "grassy-terrain"
  ],
  "evolution_chain": {
    "id": 442,
    "item": null,
    "species": [
      {
        "name": "applin",
        "order": 840,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "flapple",
        "order": 841,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "tart-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "appletun",
        "order": 842,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "sweet-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "dipplin",
        "order": 1013,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 840,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "syrupy-apple"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      },
      {
        "name": "hydrapple",
        "order": 1021,
        "types": [
          PokeType.GRASS,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": 1011,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": {
              "name": "syrup-bomb"
            },
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 169,
    "speed": 53,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
